import { IRectangle, ISpace } from 'framework/utils/math-utils';

export function convertRectangleToSpace(rect: IRectangle): ISpace {
  return {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height,
  }
}
